import { render, staticRenderFns } from "./InteractionTags.vue?vue&type=template&id=78b87e84&scoped=true&"
import script from "./InteractionTags.vue?vue&type=script&lang=js&"
export * from "./InteractionTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b87e84",
  null
  
)

export default component.exports